import {IBoosterStats} from "../../../../../../store/reducers/booster.reducer";
import {Utils} from "../../../../../../shared/utils/utils";

export class BoosterStats implements IBoosterStats {
  notCompressed: number;
  notCompressedFull: number;
  notCompressedSize: number;
  lastCompressedPercent: number;
  lastCompressedSize: number;
  reducedPercent: number;
  reducedSize: number;
  compressedFull: number;
  compressedThumbs: number;
  compressedOther: number;
  pagesCompressed: Array<any>;
  compressIsRunning: boolean;
  planLimit: number;
  limitResetDate: any;
  usedCountFromLimit: number;

  constructor(stats) {
    this.lastCompressedPercent = stats.last_compressed && stats.last_compressed.percent || 0;
    this.lastCompressedSize = stats.last_compressed && stats.last_compressed.size || 0;
    this.notCompressed = stats.not_compressed && (stats.not_compressed.thumbs + stats.not_compressed.full + stats.not_compressed.other) || 0;
    this.notCompressedSize = stats.not_compressed && stats.not_compressed.total_size || 0;
    this.notCompressedFull = stats.not_compressed && stats.not_compressed.full || 0;
    this.reducedPercent = stats.reduced && stats.reduced.total_reduced_percent || 0;
    this.reducedSize = stats.reduced && stats.reduced.total_reduced || 0;
    this.compressedFull = stats.compressed && stats.compressed.full || 0;
    this.compressedThumbs = stats.compressed && stats.compressed.thumbs || 0;
    this.compressedOther = stats.compressed && stats.compressed.other || 0;
    this.pagesCompressed = stats.pages_compressed && stats.pages_compressed || [];
    this.compressIsRunning = stats.compress_is_running && Utils.isTruthy(stats.compress_is_running) || false;
    this.planLimit = stats.limitation && stats.limitation.plan_limit || 0;
    this.limitResetDate = stats.limitation && stats.limitation.reset_date || null;
    this.usedCountFromLimit = stats.limitation && stats.limitation.already_used || 0;
  }
}
